import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import creategroup from './creategroup_new/index.vue';
import groupmapping from './GroupConnectionMappingNew/index.vue';
import groupstatus from './groupstatus/index.vue';
import locationsearch from './locationsearch/index.vue';
import addlocation from './addlocation/index.vue';
import addlocationtogroup from './addlocationtogroup/index.vue';


export default {
  name: 'vendor-company-master',
  components: {
    DatePicker,
    'first': creategroup,
    'second': groupmapping,
    'third': locationsearch,
    'fourth':addlocationtogroup,
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Create Group Destination'
        },
        {
          key: 'Second',
          value: 'Group Connection Mapping'
        },
        {
          key: 'Third',
          value: 'Location Search'
        },
        {
          key: 'Fourth',
          value: 'Add Location to Group'
        },
      ],
    }
  },
  computed: {
    // selects all checkbox's option
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/group/grouptab.component.js